import { type WorkplaceProfileResponse } from "@clipboard-health/contract-backend-main";
import { type UseGetQueryOptions } from "@src/appV2/api";
import { useGetWorkplace } from "@src/appV2/Facilities/api/useGetWorkplace";

export function useGetShiftFeedbackClockOutConfig(
  workplaceId: string,
  options?: UseGetQueryOptions<WorkplaceProfileResponse>
) {
  const {
    data: workplaceProfile,
    isLoading,
    isSuccess,
    error,
  } = useGetWorkplace({ workplaceId }, options);

  const workplaceAttributes = workplaceProfile?.data?.attributes;

  const chartingRecallEnabled = workplaceAttributes?.chartingRecall?.enabled ?? false;
  const signOutWithQrCode = workplaceAttributes?.signOutWithQrCode ?? false;
  const shiftFeedbackGiver = chartingRecallEnabled
    ? "a supervisor you worked with"
    : "a workplace employee";

  return {
    signOutWithQrCode,
    shiftFeedbackGiver,
    chartingRecallEnabled,
    isLoading,
    isSuccess,
    error,
  };
}
